import { Chip, Box } from '@mui/material';
import React from 'react';

// Import types
import type { MarketplaceService } from '../../types/pricing';

interface TermChipsProps {
  service: MarketplaceService;
  size?: 'small' | 'medium';
  variant?: 'filled' | 'outlined';
  color?: 'default' | 'primary' | 'secondary';
}

/**
 * TermChips Component
 * Displays available contract terms as small chips for marketplace tiles
 * Only shows for services with multiple contract terms
 */
export const TermChips: React.FC<TermChipsProps> = ({
  service,
  size = 'small',
  variant = 'outlined',
  color = 'primary'
}) => {
  // Only show chips if service has contract terms and more than one option
  if (!service.contract_term_months || service.contract_term_months.length <= 1) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', mt: 0.5 }}>
      {service.contract_term_months.map(term => (
        <Chip
          key={term}
          label={`${term}M`}
          size={size}
          variant={variant}
          color={color}
          sx={{
            fontSize: '0.7rem',
            height: '20px',
            '& .MuiChip-label': {
              px: 0.5,
              py: 0
            }
          }}
        />
      ))}
    </Box>
  );
};